import React from 'react';
import { authClient } from '../lib/authClient';
import { clearSessionData } from '../utils/clearSessionData';
import { Shield, LogOut } from 'lucide-react';

export default function AdminLayout({ children }) {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      height: '100dvh',
      background: '#0f0f23',
      overflow: 'hidden',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    }}>
      <div style={{
        flexShrink: 0,
        background: 'linear-gradient(135deg, #0f0f23 0%, #1a1a3e 100%)',
        borderBottom: '1px solid rgba(255,255,255,0.08)',
        padding: '0 24px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        height: 56,
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <Shield size={18} color="#667eea" />
          <span style={{ fontSize: 15, fontWeight: 700, color: '#fff', letterSpacing: '-0.01em' }}>
            GigRequest
          </span>
          <span style={{
            fontSize: 10, fontWeight: 600, color: '#667eea',
            background: 'rgba(102,126,234,0.15)', border: '1px solid rgba(102,126,234,0.3)',
            borderRadius: 4, padding: '2px 6px', letterSpacing: '0.06em', textTransform: 'uppercase',
          }}>
            Admin
          </span>
        </div>
        <button
          onClick={() => authClient.signOut().then(clearSessionData).then(() => window.location.href = '/sign-in')}
          style={{
            display: 'flex', alignItems: 'center', gap: 6,
            background: 'transparent', border: '1px solid rgba(255,255,255,0.12)',
            borderRadius: 6, padding: '6px 12px', color: 'rgba(255,255,255,0.6)',
            fontSize: 13, cursor: 'pointer',
          }}
        >
          <LogOut size={14} />
          Sign out
        </button>
      </div>

      <div style={{ flex: 1, minHeight: 0, overflowY: 'auto' }}>
        {children}
      </div>
    </div>
  );
}
